import React, {Fragment} from 'react';
import {Button, Clearfix, Col, Glyphicon, ListGroup, ListGroupItem, Panel, Row, Table} from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import EditableAction from './EditableAction';

class EditableEngagement extends React.Component {
  render() {
    const disableEdit = !!this.props.disableEdit;

    return (
      <div>
        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h3" className={'relative'}>
              <div className={!disableEdit ? 'float-vertical-align pull-left' : ''}>Goals</div>
                {
                  !disableEdit &&
                  <Fragment>
                    <div className={'pull-right'}>
                      <Button onClick={this.props.addGoal} data-cy="add-goal" className={'primary'}>Add Goal</Button>
                    </div>
                    <Clearfix/>
                  </Fragment>
                }
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table data-cy="goals-table" condensed>
              <thead>
              <tr>
                <th>Outcome</th>
                <th>as measured by</th>
                <th/>
              </tr>
              </thead>
              <tbody>
                {
                  this.props.engagement.goals ?
                  this.props.engagement.goals.map((g, i) => {
                    return (
                      <tr key={i}>
                        <td style={{ width: '400px' }}><EditableAction value={g.outcome} onSubmit={(outcome) => this.props.editGoal({ ...g, outcome }, i)}/></td>
                        <td style={{ width: '400px' }}><EditableAction value={g.measured} onSubmit={(measured) => this.props.editGoal({ ...g, measured }, i)}/></td>
                        <td className='ta-right'>
                          {
                            !disableEdit &&
                            <Button data-cy='delete-goal' onClick={() => this.props.removeGoal(g)} style={{ marginRight: '10px', height: '40px' }}>
                              <Glyphicon glyph={'remove-sign'}/>
                            </Button>
                          }
                        </td>
                      </tr>
                    );
                  })
                  :
                  <tr><td/><td/><td/></tr>
                }
              </tbody>
            </Table>
          </Panel.Body>
        </Panel>

        <Panel>
          <Panel.Body>
            <Row>
              <Col xs={6} data-cy="recs-list">
                <h4>Recommendations</h4>
                <ListGroup data-cy='recommendations-list'>
                  {
                    this.props.recommendations &&
                    this.props.recommendations.map((rId, i) => {
                      const rec = this.props.engagement.contracts.find(c => c.id === rId);

                      const getStyle = () => {
                        switch(rec.status){
                          case 'agreed':
                            return 'info';
                          case 'deferred':
                            return 'danger';
                          default:
                            return null;
                        }
                      };

                      return (
                        <ActionsListItem data-cy={`rec-list-${i}`} key={i} bsStyle={rec.complete ? 'success' : getStyle()} style={{ display: 'flex', flexDirection: 'column'}}>
                          <div className='ml-auto'><a data-cy='remove-recommendation' onClick={() => this.props.removeContract(rec)}><Glyphicon glyph={'remove-sign'}/></a></div>
                          <div style={{ margin: `${rec.complete ? '24px 0 8px 0' : '15px 0 0 0'}`, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            {
                              rec.complete ?
                                <Fragment>
                                  <ItemText>{rec.text}</ItemText>
                                  <i>Completed</i>

                                </Fragment>
                              :
                                <Fragment>
                                  <EditableAction value={rec.text} onSubmit={(text) => this.props.onSubmitContract({...rec, text})}/>
                                  {
                                    !disableEdit &&
                                    <div className='flex-row' style={{ height: '100%'}}>
                                      {
                                        rec.status !== 'deferred' &&
                                        <Button data-cy='defer-button' onClick={() => this.props.defer(rec)}>Defer</Button>
                                      }
                                      {
                                        rec.status !== 'agreed' &&
                                        <Button data-cy='agree-button' style={{ marginLeft: '5px' }} onClick={() => this.props.agree(rec)}>Agree</Button>
                                      }

                                    </div>
                                  }
                                </Fragment>
                            }
                          </div>
                        </ActionsListItem>
                      );
                    })
                  }
                </ListGroup>
                {
                  !disableEdit &&
                    <Button data-cy='add-recommendation' onClick={this.props.addRecommendation}>Add Recommendation</Button>
                }
              </Col>

              <Col xs={6} data-cy="agrees-list">
                <h4>Agreements</h4>
                <ListGroup data-cy='agreements-list'>
                  {
                    this.props.agreements &&
                    this.props.agreements.map((aId, i) => {
                      const agree = this.props.engagement.contracts.find(c => c.id === aId);

                      const getStyle = () => {
                        if (agree.complete) {
                          return 'success';
                        } else if (agree.recommendation) {
                          return 'info';
                        } else {
                          return null;
                        }
                      };

                      return (
                        <ActionsListItem data-cy={`agr-list-${i}`} key={i} bsStyle={getStyle()} style={{ display: 'flex', flexDirection: 'column'}}>
                          <div className='ml-auto'><a data-cy='remove-agreement' onClick={() => this.props.removeContract(agree)}><Glyphicon glyph={'remove-sign'}/></a></div>
                          <div className='flex-row-spaced' style={{ margin: '22px 0 8px 0', width: '100%' }}>

                            {
                              !agree.complete ?
                                <Fragment>
                                  <EditableAction value={agree.text} onSubmit={(text) => this.props.onSubmitContract({...agree, text})}/>
                                  <Button onClick={() => this.props.onSubmitContract({ ...agree, complete: true })}>Complete</Button>
                                </Fragment>
                              :
                                <Fragment>
                                  <ItemText>{agree.text}</ItemText>
                                  <Glyphicon style={{ fontSize: '20px' }} glyph='ok'/>
                                </Fragment>
                            }
                          </div>
                        </ActionsListItem>
                      );
                    })
                  }
                </ListGroup>
                {
                  !disableEdit &&
                    <Button data-cy='add-agreement-button' onClick={this.props.addAgreement}>Add Agreement</Button>
                }
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

const ActionsListItem = styled(ListGroupItem)`
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;   
   min-height: 56px;
`;

const ItemText = styled.span`
   word-wrap: break-word;
   white-space: normal;
   word-break: break-all;
   max-width: 25rem;
`;

EditableEngagement.propTypes = {
  engagement: PropTypes.shape({
    goals: PropTypes.array,
  }).isRequired,
  recommendations: PropTypes.array,
  agreements: PropTypes.array,
  removeContract: PropTypes.func.isRequired,
  removeGoal: PropTypes.func.isRequired,
  agree: PropTypes.func.isRequired,
  defer: PropTypes.func.isRequired,
  addRecommendation: PropTypes.func.isRequired,
  addAgreement: PropTypes.func.isRequired,
  addGoal: PropTypes.func.isRequired,
  disableEdit: PropTypes.bool,
  onSubmitContract: PropTypes.func.isRequired,
  editGoal: PropTypes.func.isRequired,
};

export default EditableEngagement;


// WEBPACK FOOTER //
// ./src/components/engagement/EditableEngagement.js